import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSecurity = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M20 14V5.658c0-.4-.238-.76-.606-.918l-5-2.142A1 1 0 0 0 13 3.517v16.967c0 .717.726 1.181 1.35.826C16.384 20.154 20 17.594 20 14Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M4 5.658V14c0 3.594 3.616 6.154 5.65 7.31.624.355 1.35-.108 1.35-.826V3.517a1 1 0 0 0-1.394-.92l-5 2.143A.997.997 0 0 0 4 5.658Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcSecurity");

export { IcSecurity };
//# sourceMappingURL=ic-security.js.map
